import { Routes } from './index'

export const ADOBE_MARKETING_CLOUD_ORGANIZATION_ID = '372F3B7558540F0E0A495EEB@AdobeOrg'

export default {
  [Routes.CLIENT_ADDITIONAL_INFO]: 'Klient dalsi udaje',
  [Routes.CLIENT_ADDRESS]: 'Klient adresa',
  [Routes.CLIENT_CHECKS]: 'Klient rozcestnik',
  [Routes.CLIENT_DETAILS]: 'Klient detail',
  [Routes.CLIENT_INFO]: 'Kontaktni udaje',
  [Routes.CLIENT_SCORING]: 'Scoring',
  [Routes.CONTRACT_SIGN]: 'Podpis smlouvy bankou',
  [Routes.CONTRACT]: 'Smlouva',
  [Routes.EXIT]: 'Exit',
  [Routes.FINAL]: 'Victory',
  [Routes.FINANCE_EMPLOYER]: 'Zamestnavatel',
  [Routes.FINANCE_EXPENSES]: 'Vydaje',
  [Routes.FINANCE_INCOME]: 'Prijem',
  [Routes.FINANCE_PROFESSION]: 'Povolani',
  [Routes.IDENTITY]: 'Overeni identity',
  [Routes.KO_ONLINE]: 'Nejde online',
  [Routes.KO_SCORING]: 'Zamitnuto',
  [Routes.LOAN_CONFIGURATOR_RE]: 'Nastaveni uveru po potvrzeni prijmu',
  [Routes.LOAN_CONFIGURATOR]: 'Nastaveni uveru po scoringu',
  [Routes.NOT_FOUND]: 'Stranka nebyla nalezena',
  [Routes.NOT_IMPLEMENTED_PAGE]: 'Neimplementovaná stranka',
  [Routes.OK_BRANCH]: 'Victory pobocka',
  [Routes.PENNY_PAYMENT_CONFIRM]: 'Korunova platba potvrzeni',
  [Routes.PENNY_PAYMENT]: 'Korunova platba',
  [Routes.POST_PROCESSING]: 'Post processing', // todo nejaka kontrola
  [Routes.POP_UPLOAD]: 'Potvrzeni o prijmu',
  [Routes.POP_PROCESSING]: 'Potvrzeni o prijmu ',
  [Routes.PRE_CONTRACT]: 'Predsmluvni informace',
  [Routes.PRINT_CONTRACT]: 'Tisk smlouvy',
  [Routes.PRINT_PRE_CONTRACT]: 'Tisk predsmluvni informace',
  [Routes.RECAPITULATION]: 'Rekapitulace',
}
